import { Card } from "antd";
import React from "react";

function ListAppCard({
  uniqueApps,
  isWindows,
  windowsSusAppData,
  macSusAppData,
}) {
  const suspiciousApps = uniqueApps?.filter((app) =>
    isWindows
      ? windowsSusAppData?.includes(app?.name)
      : macSusAppData?.includes(app?.name),
  );

  return (
    <Card className="bg-[#D4E7FD] mt-4 border-2 border-[#A9CFFB]  w-full ">
      <div className="flex md:flex-row flex-col justify-between gap-6 w-full">
        <div className="md:w-1/2 w-full">
          <div className=" text-center rounded-lg px-8 py-7 bg-white h-full">
            <p className="text-xl font-semibold text-[#475467] text-center">
              All Applications{" "}
              <span className="text-blue-500">({uniqueApps?.length || 0})</span>
            </p>

            <div className="mt-2 text-blue-500 font-medium max-h-[100px] overflow-y-auto scroll">
              {uniqueApps?.map((app, index) => {
                const isMatched = isWindows
                  ? windowsSusAppData?.includes(app?.name)
                  : macSusAppData?.includes(app?.name);

                return (
                  <div key={app.pid} className={`mb-1`}>
                    {index + 1}. {app?.name}
                  </div>
                );
              })}
            </div>
          </div>
          <div className="text-red-500 md:w-1/2 pl-1 md:hidden block">
            <p>
              <strong>Note: </strong>
              This shows the total number of applications running during the
              interview. A higher number of running applications may result in a
              lower integrity.
            </p>
          </div>
        </div>
        <div className="md:w-1/2 w-full">
          <div className=" text-center rounded-lg px-8 py-7 bg-white  h-full">
            <p className="text-xl font-semibold text-[#475467] text-center">
              Suspicious Application{" "}
              <span className="text-red-500">({suspiciousApps?.length})</span>
              {suspiciousApps?.length === 1 ? "" : "s"}
            </p>

            <div className="mt-2 text-blue-500 font-medium max-h-[100px] overflow-y-auto scroll">
              {uniqueApps
                ?.filter((app) =>
                  isWindows
                    ? windowsSusAppData?.includes(app?.name)
                    : macSusAppData?.includes(app?.name),
                )
                ?.map((app, index) => (
                  <div
                    key={app.pid}
                    className="mb-1 text-red-500 font-semibold"
                  >
                    {index + 1}. {app?.name}
                  </div>
                ))}
            </div>
          </div>
          <div className="text-red-500 md:w-1/2 pl-1 md:hidden block">
            <p>
              <strong>Note: </strong> This shows the suspicious applications
              detected during the interview. The presence of such applications
              is not permitted and may significantly reduce the integrity.
            </p>
          </div>
        </div>
      </div>
      <div className="md:flex hidden md:flex-row flex-col  gap-6 mt-1">
        <div className="text-red-500 md:w-1/2 pl-1">
          <p>
            <strong>Note: </strong>
            This shows the total number of applications running during the
            interview. A higher number of running applications may result in a
            lower integrity.
          </p>
        </div>
        <div className="text-red-500 md:w-1/2 pl-1">
          <p>
            <strong>Note: </strong> This shows the suspicious applications
            detected during the interview. The presence of such applications is
            not permitted and may significantly reduce the integrity.
          </p>
        </div>
      </div>
    </Card>
  );
}

export default ListAppCard;
